export default {
    name: 'en',
    messages: {
        max_stripped_length: (field, [length]) => `The ${field} field must be no more than ${length} characters.`,
        min_stripped_length: (field, [length]) => `The ${field} field must be at least ${length} characters.`,
        max_dimensions: (field, [height, width]) => `The ${field} field must be no more than ${height} pixels tall and ${width} pixels wide.`,
        min_dimensions: (field, [height, width]) => `The ${field}field must be at least ${height} pixels tall and ${width} pixels wide.`,
    },
};



// WEBPACK FOOTER //
// ./src/global/validation/localization/en.js